import { render, staticRenderFns } from "./CumplimientoPL.vue?vue&type=template&id=a23b0c9a&scoped=true&"
import script from "./CumplimientoPL.vue?vue&type=script&lang=js&"
export * from "./CumplimientoPL.vue?vue&type=script&lang=js&"
import style0 from "./CumplimientoPL.vue?vue&type=style&index=0&id=a23b0c9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23b0c9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VIcon})
